/*
 * <density-toggle> — the collection grid's four-up / two-up control.
 *
 * The prototype's filter bar carries two small buttons that switch the desktop
 * grid between four and two columns. Craft has no equivalent, so this is a new
 * control.
 *
 * The chosen density is written to <body data-plp-cols> and not to the grid,
 * because applying a facet filter replaces #ProductGridContainer's innerHTML
 * (see FacetFiltersForm.renderProductGridContainer in facets.js) and would
 * silently drop a class set on #product-grid. The columns themselves are CSS —
 * see section-collection-plp.css.
 */
const PLP_DENSITY_KEY = 'ih:plp-cols';

if (!customElements.get('density-toggle')) {
  customElements.define(
    'density-toggle',
    class DensityToggle extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('button[data-cols]'));

        let stored = null;
        try {
          stored = localStorage.getItem(PLP_DENSITY_KEY);
        } catch (e) {
          // Private browsing can throw on access; the default density is fine.
        }

        this.apply(stored || this.dataset.default || '4', false);

        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.apply(button.dataset.cols, true));
        });
      }

      apply(cols, persist) {
        const known = this.buttons.some((button) => button.dataset.cols === cols);
        if (!known) return;

        document.body.dataset.plpCols = cols;
        this.buttons.forEach((button) => {
          button.setAttribute('aria-pressed', button.dataset.cols === cols ? 'true' : 'false');
        });

        if (!persist) return;
        try {
          localStorage.setItem(PLP_DENSITY_KEY, cols);
        } catch (e) {
          // Not being able to remember the choice is not worth failing over.
        }
      }
    },
  );
}
